// Import images
import bill1000 from "../../../images/cash/100_dollar.png"; // Reusing for 1000
import bill100 from "../../../images/cash/100_dollar.png";
import bill50 from "../../../images/cash/50_dollar.png";
import bill10 from "../../../images/cash/10_dollar.png";
import bill5 from "../../../images/cash/5_dollar.png";
import bill2 from "../../../images/cash/1_dollar.png";
import bill1 from "../../../images/cash/1_dollar.png";
import coin50c from "../../../images/cash/50_cents.png";
import coin20c from "../../../images/cash/25_cents.png"; // Fallback
import coin10c from "../../../images/cash/10_cents.png";
import coin5c from "../../../images/cash/5_cents.png";

export const requestsMockData = [
  {
    id: "297",
    date: "2026-03-10",
    displayDate: "10/03/2026",
    time: "11:18:21",
    type: "Replenishment (Vault to Cash)",
    typeValue: "replenishment",
    amount: "2,000",
    amended: "No",
    status: "New",
    statusValue: "new",
    drawerId: "Hanh Nguyen",
    createdBy: "Teller 1",
    currency: "Singapore Dollar (SGD)",
    totalCash: "111,419",
    notes: "",
    denominations: [
      { id: "bill1000", label: "1000 Dollars", value: 1000, inventory: 0, qty: 2, image: bill1000 },
      { id: "bill100", label: "100 Dollars", value: 100, inventory: 99, qty: 0, image: bill100 },
      { id: "bill50", label: "50 Dollars", value: 50, inventory: 9, qty: 0, image: bill50 },
      { id: "bill10", label: "10 Dollars", value: 10, inventory: 1, qty: 0, image: bill10 },
      { id: "bill5", label: "5 Dollars", value: 5, inventory: 1, qty: 0, image: bill5 },
      { id: "bill2", label: "2 Dollars", value: 2, inventory: 2, qty: 0, image: bill2 },
      { id: "bill1", label: "1 Dollar", value: 1, inventory: 50, qty: 0, image: bill1 },
      { id: "coin50c", label: "50 Cents", value: 0.5, inventory: "-", qty: 0, image: coin50c },
      { id: "coin20c", label: "20 Cents", value: 0.2, inventory: "-", qty: 0, image: coin20c },
      { id: "coin10c", label: "10 Cents", value: 0.1, inventory: "-", qty: 0, image: coin10c },
      { id: "coin5c", label: "5 Cents", value: 0.05, inventory: "-", qty: 0, image: coin5c },
    ],
  },
  {
    id: "296",
    date: "2026-03-09",
    displayDate: "09/03/2026",
    time: "14:22:55",
    type: "Withdrawal (Cash to Vault)",
    typeValue: "withdrawal",
    amount: "5,000",
    amended: "No",
    status: "In Progress",
    statusValue: "inprogress",
    drawerId: "Alex Doe",
    createdBy: "Teller 2",
    currency: "Singapore Dollar (SGD)",
    totalCash: "106,419",
    notes: "Please process this soon.",
    denominations: [
      { id: "bill1000", label: "1000 Dollars", value: 1000, inventory: 5, qty: 5, image: bill1000 },
      { id: "bill100", label: "100 Dollars", value: 100, inventory: 99, qty: 0, image: bill100 },
      { id: "bill50", label: "50 Dollars", value: 50, inventory: 9, qty: 0, image: bill50 },
      { id: "bill10", label: "10 Dollars", value: 10, inventory: 1, qty: 0, image: bill10 },
      { id: "bill5", label: "5 Dollars", value: 5, inventory: 1, qty: 0, image: bill5 },
      { id: "bill2", label: "2 Dollars", value: 2, inventory: 2, qty: 0, image: bill2 },
      { id: "bill1", label: "1 Dollar", value: 1, inventory: 50, qty: 0, image: bill1 },
      { id: "coin50c", label: "50 Cents", value: 0.5, inventory: "-", qty: 0, image: coin50c },
      { id: "coin20c", label: "20 Cents", value: 0.2, inventory: "-", qty: 0, image: coin20c },
      { id: "coin10c", label: "10 Cents", value: 0.1, inventory: "-", qty: 0, image: coin10c },
      { id: "coin5c", label: "5 Cents", value: 0.05, inventory: "-", qty: 0, image: coin5c },
    ],
  },
  {
    id: "295",
    date: "2026-03-08",
    displayDate: "08/03/2026",
    time: "09:15:00",
    type: "Update Cash Drawer",
    typeValue: "updateCashDrawer",
    amount: "1,500",
    amended: "No",
    status: "New",
    statusValue: "new",
    drawerId: "John Smith",
    createdBy: "Teller 3",
    currency: "Singapore Dollar (SGD)",
    totalCash: "107,919",
    notes: "Updating drawer for morning shift.",
    denominations: [
      { id: "bill100", label: "100 Dollars", value: 100, inventory: 10, qty: 10, image: bill100 },
      { id: "bill50", label: "50 Dollars", value: 50, inventory: 10, qty: 10, image: bill50 },
    ],
  },
];
